import styled from "styled-components";
import { AuthorizationManagementWrapper } from "@/pages/authorization-management/atom";

export const LeftPart = styled.div`
  max-width: 513px;
  .title {
    font-style: normal;
    font-weight: 500;
    font-size: 36px;
    line-height: 36px;
    color: rgba(255, 255, 255, 0.85);
    margin-bottom: 38px;
  }
  .tip {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 82px;
  }
  button {
    width: 136px;
    min-height: 40px;
    background: var(--main-color);
    border: unset;
    border-radius: 4px;
    cursor: pointer;
    color: #fff;
  }
`;
export const RightPart = styled.div`
  margin-left: 8.64vw;
`;

export const ClosePageWrapper = styled(AuthorizationManagementWrapper)`
  display: flex;
  padding: 26.66vh 0 0 13.229vw;
  width: 100%;
  min-width: max-content;
`;
